<!--
 * @Author: wangyan1 wangyan1
 * @Date: 2023-10-19 14:50:50
 * @LastEditors: wangyan1 wangyan1
 * @LastEditTime: 2023-10-19 16:35:20
 * @FilePath: /teacher-xkh-web/src/components/TextTagNew.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <span class="text" :class="[className]">
    {{ words }}
  </span>
</template>
<script>
export default {
  props: {
    className: {
      type: String,
      default: 'green'
    },
    words: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/static/css/colors.less';
.text{
  display: inline-block;
  position:absolute;
  right: 0;
  top:  0px;
  font-family: 'Microsoft YaHei UI';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  letter-spacing: 0.04em;
  color: #FFFFFF;
  background: #3262FD;
  border-bottom-left-radius: 4px;
  padding: 0 4px;
}
.yellow {
  color: #82532A;
  background: #FFE0B7;
}
</style>